import v2021 from '@/sui/data/sheets/edit/observa4/2021'

import ctx from '@/sui/data/caracteristics/observa4/context'
import { fromField } from '@/sui/data/caracteristics/tools'

const ofields = v2021.fields

export default {
  p1: [
    fromField('p1b lieu', ofields.place.p1),
    fromField('p1b lieu autre', ofields.otherPlace.p1),
    fromField('p1b dispositif', ofields.catheterType.p1),
    fromField('p1b dispositif autre (2021+)', ofields.otherCatheterType.p1),
    { f: 'p1b audité', t: `L'audité`, h: true },
    fromField('p1b audité', ofields.audited.p1p3),
    fromField('p1b étudiant', ofields.student.all),
    fromField('p1b casaque stérile', ofields.sterileGown.p1),
    fromField('p1b coiffe audité', ofields.auditedCap.p1p3),
    fromField('p1b coiffe conforme audité', ofields.compliantAuditedCap.p1p3),
    fromField('p1b masque audité', ofields.auditedMask.p1p3b2),
    fromField('p1b masque conformité audité', ofields.compliantAuditedMask.p1p3b2),
    { f: 'p1b adulte', t: 'Le patient', h: true },
    fromField('p1b adulte', ofields.isAdult.p1p2p3),
    fromField('p1b âge enfant', ofields.childAge.p1p2p3),
    fromField('p1b tenue propre patient', ofields.patientCleanOutfit.p1p2p3b2),
    fromField('p1b masque patient', ofields.patientMask.p1p3b2, 3),
    fromField('p1b masque conforme patient', ofields.compliantPatientMask.p1p3b2),
    fromField('p1b visage couvert patient', ofields.patientSterileField.p1),
    fromField('p1b coiffe patient', ofields.patientCap.p1),
    fromField('p1b coiffe conforme patient', ofields.compliantPatientCap.p1),
    { f: 'p1b peau nécessitant nettoyage', t: `Préparation du site d'insertion`, h: true },
    fromField('p1b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3),
    fromField('p1b nettoyage', ofields.insertionSiteCleaned.p1p2p3),
    fromField('p1b application antiseptique', ofields.antiseptic.p1p2p3[0]),
    fromField('p1b antiseptique', ofields.antiseptic.p1p2p3[1]),
    fromField('p1b antiseptique autre', ofields.antiseptic.p1p2p3[2]),
    fromField('p1b compresses (2021+)', ofields.useCompresses.p1p2p3, 3),
    fromField('p1b type compresses (2021+)', ofields.compressesType.p1p2p3),
    fromField('p1b nb passages antiseptique (2021+)', ofields.antisepticPassages.p1p2p3),
    fromField('p1b séchage spontané', ofields.dry.p1p2p3, null, null, ctx.p1),
    { f: 'p1b hdm pose', t: `Pose du dispositif`, h: true },
    fromField('p1b hdm pose', ofields.handHygieneBeforeInsertion.p1[0]),
    fromField('p1b hdm pose type (2022-)', ofields.handHygieneBeforeInsertion.p1[1]),
    fromField('p1b hdm pose conforme', ofields.handHygieneBeforeInsertion.p1[2]),
    fromField('p1b gants pose (2021+)', ofields.gloves.p1p2p3b1),
    fromField('p1b gants pose type (2021+)', ofields.glovesType.p1p2p3b1),
    { f: 'p1b pkoi tenue audité non conforme (2023-)', t: `Entretien avec l'audité`, h: true },
    fromField('p1b pkoi tenue audité non conforme (2023-)', ofields.whyNCAuditedOutfit.p1p3[0]),
    fromField('p1b pkoi tenue audité non conforme autre (2023-)', ofields.whyNCAuditedOutfit.p1p3[1]),
    fromField('p1b pkoi asq non alcoolique adulte (2023-)', ofields.whyNotAlcool.p1p2p3[0]),
    fromField('p1b pkoi asq non alcoolique adulte autre (2023-)', ofields.whyNotAlcool.p1p2p3[1]),
    fromField('p1b pkoi pas dcmf (2023-)', ofields.whyNotHHC.p1[0]),
    fromField('p1b pkoi pas dcmf autre (2023-)', ofields.whyNotHHC.p1[1])
  ],

  p2: [
    fromField('p2b dispositif', ofields.catheterType.p2),
    { f: 'p2b audité', t: `L'audité`, h: true },
    fromField('p2b audité', ofields.audited.p2b1b2),
    fromField('p2b étudiant', ofields.student.all),
    fromField('p2b tenue propre audité', ofields.auditedCleanOutfit.p2p3b1b2),
    { f: 'p2b adulte', t: 'Le patient', h: true },
    fromField('p2b adulte', ofields.isAdult.p1p2p3),
    fromField('p2b âge enfant', ofields.childAge.p1p2p3),
    fromField('p2b tenue propre patient', ofields.patientCleanOutfit.p1p2p3b2),
    { f: 'p2b prepa hdm', t: `Préparation du site d'insertion`, h: true },
    fromField('p2b prepa hdm', ofields.handHygieneBeforePreparation.p2p3[0]),
    fromField('p2b prepa hdm type', ofields.handHygieneBeforePreparation.p2p3[1]),
    fromField('p2b prepa hdm conforme', ofields.handHygieneBeforePreparation.p2p3[2]),
    fromField('p2b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3),
    fromField('p2b nettoyage', ofields.insertionSiteCleaned.p1p2p3),
    fromField('p2b application antiseptique', ofields.antiseptic.p1p2p3[0]),
    fromField('p2b antiseptique', ofields.antiseptic.p1p2p3[1]),
    fromField('p2b antiseptique autre', ofields.antiseptic.p1p2p3[2]),
    fromField('p2b compresses (2021+)', ofields.useCompresses.p1p2p3, 3),
    fromField('p2b type compresses (2021+)', ofields.compressesType.p1p2p3),
    fromField('p2b nb passages antisptique (2021+)', ofields.antisepticPassages.p1p2p3),
    fromField('p2b séchage spontané', ofields.dry.p1p2p3, null, null, ctx.p2),
    { f: 'p2b pose hdm', t: `Insertion du catheter`, h: true },
    fromField('p2b pose hdm', ofields.handHygieneBeforePeriInsertion.p2[0]),
    fromField('p2b pose hdm type', ofields.handHygieneBeforePeriInsertion.p2[1]),
    fromField('p2b pose hdm conforme', ofields.handHygieneBeforePeriInsertion.p2[2]),
    fromField('p2b pose gants', ofields.gloves.p1p2p3b1),
    fromField('p2b pose gants type', ofields.glovesType.p1p2p3b1),
    fromField('p2b palpation', ofields.palpation.p2),
    { f: 'p2b pkoi asq non alcoolique adulte', t: `Entretien avec l'audité`, h: true },
    fromField('p2b pkoi asq non alcoolique adulte', ofields.whyNotAlcool.p1p2p3[0]),
    fromField('p2b pkoi asq non alcoolique adulte autre', ofields.whyNotAlcool.p1p2p3[1]),
    fromField('p2b pkoi pas hdm insertion', ofields.whyNotHH.p2[0]),
    fromField('p2b pkoi pas hdm insertion autre', ofields.whyNotHH.p2[1]),
    fromField('p2b pkoi pas de gants (2023-)', ofields.whyNotGloves.p2[0]),
    fromField('p2b pkoi pas de gants autre (2023-)', ofields.whyNotGloves.p2[1])
  ],

  p3: [
    { f: 'p3b audited', t: `L'audité`, h: true },
    fromField('p3b audité', ofields.audited.p1p3),
    fromField('p3b étudiant', ofields.student.all),
    fromField('p3b tenue propre audité', ofields.auditedCleanOutfit.p2p3b1b2),
    fromField('p3b coiffe audité', ofields.auditedCap.p1p3),
    fromField('p3b coiffe conforme audité', ofields.compliantAuditedCap.p1p3),
    fromField('p3b masque audité', ofields.auditedMask.p1p3b2),
    fromField('p3b masque conforme audité', ofields.compliantAuditedMask.p1p3b2),
    { f: 'p3b adulte', t: 'Le patient', h: true },
    fromField('p3b adulte', ofields.isAdult.p1p2p3),
    fromField('p3b âge enfant', ofields.childAge.p1p2p3),
    fromField('p3b tenue propre patient', ofields.patientCleanOutfit.p1p2p3b2),
    fromField('p3b masque patient', ofields.patientMask.p1p3b2),
    fromField('p3b masque conforme patient', ofields.compliantPatientMask.p1p3b2),
    fromField('p3b visage tourné patient', ofields.patientOtherSide.p3b2),

    {
      f: 'p3b prepa hdm',
      t: `Préparation du site de pose de l'aiguille`,
      h: true
    },
    fromField('p3b prepa hdm', ofields.handHygieneBeforePreparation.p2p3[0]),
    fromField('p3b prepa hdm type', ofields.handHygieneBeforePreparation.p2p3[1]),
    fromField('p3b prepa hdn conforme', ofields.handHygieneBeforePreparation.p2p3[2]),
    fromField('p3b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3),
    fromField('p3b nettoyage', ofields.insertionSiteCleaned.p1p2p3),
    fromField('p3b application antiseptique', ofields.antiseptic.p1p2p3[0]),
    fromField('p3b antiseptique', ofields.antiseptic.p1p2p3[1]),
    fromField('p3b antiseptique autre', ofields.antiseptic.p1p2p3[2]),
    fromField('p3b compresses (2021+)', ofields.useCompresses.p1p2p3, 3),
    fromField('p3b type compresses (2021+)', ofields.compressesType.p1p2p3),
    fromField('p3b nb passages antisptique (2021+)', ofields.antisepticPassages.p1p2p3),
    fromField('p3b séchage spontané', ofields.dry.p1p2p3, null, null, ctx.p3),
    { f: 'p3b ponction hdm (2023-)', t: `Pose de l'aiguille`, h: true },
    fromField('p3b ponction hdm (2023-)', ofields.handHygieneBeforePuncture.p3[0]),
    fromField('p3b ponction hdm type (2023-)', ofields.handHygieneBeforePuncture.p3[1]),
    fromField('p3b ponction hdm conforme (2023-)', ofields.handHygieneBeforePuncture.p3[2]),
    fromField('p3b gants', ofields.gloves.p1p2p3b1),
    fromField('p3b gants type', ofields.glovesType.p1p2p3b1),
    { f: 'p3b pkoi tenue audité non conforme', t: `Entretien avec l'audité`, h: true },
    fromField('p3b pkoi tenue audité non conforme', ofields.whyNCAuditedOutfit.p1p3[0]),
    fromField('p3b pkoi tenue audité non conforme autre', ofields.whyNCAuditedOutfit.p1p3[1]),
    fromField('p3b pkoi tenue patient non conforme', ofields.whyNCPatientOutfit.p3b2[0]),
    fromField('p3b pkoi tenue patient non conforme autre', ofields.whyNCPatientOutfit.p3b2[1]),
    fromField('p3b pkoi asq non alcoolique adulte', ofields.whyNotAlcool.p1p2p3[0]),
    fromField('p3b pkoi asq non alcoolique adulte autre', ofields.whyNotAlcool.p1p2p3[1]),
    fromField('p3b pkoi pas hdm avant ponction (2023-)', ofields.whyNotHHP.p3[0]),
    fromField('p3b pkoi pas hdm avant ponction autre (2023-)', ofields.whyNotHHP.p3[1])
  ],

  b1: [
    fromField('b1b dispositif', ofields.catheterType.b1),
    fromField('b1b dispositif autre (2021+)', ofields.otherCatheterType.b1),
    { f: 'b1b audité', t: `L'audité`, h: true },
    fromField('b1b audité', ofields.audited.p2b1b2),
    fromField('b1b étudiant', ofields.student.all),
    fromField('b1b tenue propre audité', ofields.auditedCleanOutfit.p2p3b1b2),
    {
      f: 'b1b manip hdm',
      t: `Manipulation`,
      h: true
    },
    fromField('b1b manip hdm', ofields.handHygieneBeforeManip.b1[0]),
    fromField('b1b manip hdm type', ofields.handHygieneBeforeManip.b1[1]),
    fromField('b1b manip hdm conforme', ofields.handHygieneBeforeManip.b1[2]),
    fromField('b1b compresses (2021+)', ofields.useCompresses.b1b2, 3),
    fromField('b1b compresses type (2021+)', ofields.compressesType.b1b2),
    fromField('b1b application antiseptique', ofields.antiseptic.b1[0]),
    fromField('b1b antiseptique', ofields.antiseptic.b1[1]),
    fromField('b1b antiseptique autre', ofields.antiseptic.b1[2]),
    { f: 'b1b valve', t: `Valve`, h: true },
    fromField('b1b valve', ofields.valve.b1b2),
    fromField('b1b valve désinfection', ofields.valveAntiseptic.b1b2[0]),
    fromField('b1b valve désinfection conforme', ofields.valveAntiseptic.b1b2[1]),
    fromField('b1b valve antiseptique', ofields.valveAntiseptic.b1b2[2]),
    fromField('b1b valve antiseptique autre', ofields.valveAntiseptic.b1b2[3]),

    fromField('b1b gants', ofields.gloves.p1p2p3b1),
    fromField('b1b gants type (2021+)', ofields.glovesType.p1p2p3b1),
    fromField('b1b gants justifiés (2021-)', ofields.glovesJustified.b1),

    { f: 'b1b pkoi pas hdm manipulation', t: `Entretien avec l'audité`, h: true },
    fromField('b1b pkoi pas hdm manipulation', ofields.whyNotHHM.b1[0]),
    fromField('b1b pkoi pas hdm manipulation autre', ofields.whyNotHHM.b1[1]),
    fromField('b1b pkoi pas compresses désinfection (2021+)', ofields.whyNotCompresses.b1[0]),
    fromField('b1b pkoi pas compresses désinfection autre (2021+)', ofields.whyNotCompresses.b1[1]),
    fromField('b1b pkoi pas stériles compresses (2021+)', ofields.whyNotSterileCompresses.b1[0]),
    fromField('b1b pkoi pas stériles compresses autre (2021+)', ofields.whyNotSterileCompresses.b1[1]),
    fromField('b1b pkoi pas valve désinfectée', ofields.whyNotDisinfectValve.b1b2[0]),
    fromField('b1b pkoi pas valve désinfectée autre', ofields.whyNotDisinfectValve.b1b2[1])
  ],

  b2: [
    fromField('b2b dispositif', ofields.catheterType.b2),
    fromField('b2b dispositif autre (2021-2023)', ofields.otherCatheterType.b2),
    { f: 'b2b audité', t: `L'audité`, h: true },
    fromField('b2b audité', ofields.audited.p2b1b2),
    fromField('b2b étudiant', ofields.student.all),
    fromField('b2b tenue propre audité', ofields.auditedCleanOutfit.p2p3b1b2),
    fromField('b2b gants (2021+)', ofields.gloves.b2),
    fromField('b2b gants type (2021+)', ofields.glovesType.b2),
    fromField('b2b masque audité', ofields.auditedMask.p1p3b2),
    fromField('b2b masque conforme audité', ofields.compliantAuditedMask.p1p3b2),

    { f: 'b2b tenue propre patient', t: `Le patient`, h: true },
    fromField('b2b tenue propre patient', ofields.patientCleanOutfit.p1p2p3b2),
    fromField('b2b masque patient', ofields.patientMask.p1p3b2),
    fromField('b2b masque conforme patient', ofields.compliantPatientMask.p1p3b2),
    fromField('b2b visage tourné patient', ofields.patientOtherSide.p3b2),

    {
      f: 'b2b hdm avant gants (2022-)',
      t: `Préparation du site de branchement`,
      h: true
    },
    fromField('b2b hdm avant gants (2022-)', ofields.handHygieneBeforeGloves.b2[0]),
    fromField('b2b hdm avant gants type (2022-)', ofields.handHygieneBeforeGloves.b2[1]),
    fromField('b2b hdm avant gants conforme (2022-)', ofields.handHygieneBeforeGloves.b2[2]),

    fromField('b2b compresses (2021+)', ofields.useCompresses.b1b2, 3),
    fromField('b2b type compresses (2021+)', ofields.compressesType.b1b2),
    fromField('b2b application antiseptique', ofields.antiseptic.b2[0]),
    fromField('b2b antiseptique', ofields.antiseptic.b2[1]),
    fromField('b2b antiseptique autre', ofields.antiseptic.b2[2]),

    { f: 'b2b valve', t: `Valve`, h: true },
    fromField('b2b valve', ofields.valve.b1b2),
    fromField('b2b valve désinfection', ofields.valveAntiseptic.b1b2[0]),
    fromField('b2b valve désinfection conforme (2021+)', ofields.valveAntiseptic.b1b2[1]),
    fromField('b2b valve antiseptique', ofields.valveAntiseptic.b1b2[2]),
    fromField('b2b valve antiseptique autre', ofields.valveAntiseptic.b1b2[3]),

    { f: 'b2b pkoi audité pas masque', t: `Entretien avec l'audité`, h: true },
    fromField('b2b pkoi audité pas masque', ofields.whyNotAuditedMask.b2[0]),
    fromField('b2b pkoi audité pas masque autre', ofields.whyNotAuditedMask.b2[1]),
    fromField('b2b pkoi tenue patient pas conforme (2023-)', ofields.whyNCPatientOutfit.p3b2[0]),
    fromField('b2b pkoi tenue patient pas conforme autre (2023-)', ofields.whyNCPatientOutfit.p3b2[1]),
    fromField('b2b pkoi pas hdm manip', ofields.whyNotHHM.b2[0]),
    fromField('b2b pkoi pas hdm manip autre', ofields.whyNotHHM.b2[1]),
    fromField('b2b pkoi pas valve désinfectée', ofields.whyNotDisinfectValve.b1b2[0]),
    fromField('b2b pkoi pas valve désinfectée autre', ofields.whyNotDisinfectValve.b1b2[1])
  ]
}
